import { IOrderBasis } from '../entities/orderBasis';

/**
 * 発注根拠のデータを生成するファクトリークラス
 */
export class OrderBasisFactory {
  /**
   * IOrderBasisを生成する
   * @param initialData - 初期値
   */
  public static create = (initialData: Partial<IOrderBasis> = {}): IOrderBasis => {
    const orderBasis: IOrderBasis = {
      orderBasisId: initialData.orderBasisId ?? undefined,
      snapshotLatestInventoryAmount: initialData.snapshotLatestInventoryAmount ?? 0,
      snapshotExecutionDate: initialData.snapshotExecutionDate ?? 0,
      snapshotPackage: initialData.snapshotPackage ?? 0,
      snapshotMoq: initialData.snapshotMoq,
      userAdjustedLeadTime: initialData.userAdjustedLeadTime ?? { value: 0, unit: 'day' },
      userAdjustedStdInventoryIndex: initialData.userAdjustedStdInventoryIndex ?? { min: 0, max: 0, option: { unit: 'day' } },
      nextMonthlyInfos: initialData.nextMonthlyInfos ?? [],
      pastMonthlyInfos: initialData.pastMonthlyInfos ?? [],
      customerAnnounceDaily: initialData.customerAnnounceDaily ?? [],
    };
    return orderBasis;
  };
}
